export const forceClearAllAppCookies = () => {
    if (typeof document === "undefined") return
    const cookies = document.cookie ? document.cookie.split(";") : []
    const host = window.location.hostname.toLowerCase()
    if (!host.includes("mapnova")) return

    const hostParts = host.split(".")
    // take segments before "mapnova"; support sub.sub domains by grabbing the last pre-mapnova label
    const mapnovaIndex = hostParts.findIndex((part) => part === "mapnova")
    const subdomain = mapnovaIndex > 0 ? hostParts[mapnovaIndex - 1] : hostParts[0] || "app" // fallback

    const domains = [
        `.${subdomain}.mapnova.com`,
        `${subdomain}.mapnova.com`,
        ".mapnova.com",
        "mapnova.com",
    ]

    cookies.forEach((cookie) => {
        const eqPos = cookie.indexOf("=")
        const name = eqPos > -1 ? cookie.slice(0, eqPos).trim() : cookie.trim()
        if (!name) return
        // clear host-only
        document.cookie = `${name}=; Max-Age=0; path=/`
        // clear common mapnova domains
        domains.forEach((domain) => {
            document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`
        })
    })
}
